import React from 'react';
import { Box, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

const BulkUploadProcessedStatusBar = ({ totalProcessedDocuments, totalUploadedDocuments, status }) => {
  const processed = Number(totalProcessedDocuments) || 0;
  const total = Number(totalUploadedDocuments) || 0;
  const failed = Math.max(total - processed, 0);

  const processedPercentage = total > 0 ? (processed / total) * 100 : 0;

  const failedPercentage = total > 0 ? (failed / total) * 100 : 0;

  const uploadStatusInfo = `${processed} - Successful\n` + `${failed} - Failed\n` + `${total} - Total`;

  const normalizedStatus = status?.toUpperCase();

  if (total === 0 || normalizedStatus === 'UPLOADED' || normalizedStatus === 'PROCESSING') {
    return '-';
  }

  return (
    <Tooltip
      title={uploadStatusInfo}
      slotProps={{
        tooltip: {
          sx: {
            border: '1px solid #E5E7EB',
            borderRadius: '12px',
            boxShadow: '0px 4px 12px rgba(16, 24, 40, 0.12)',
            whiteSpace: 'pre-line',
            fontSize: '12px',
            fontWeight: 400,
            fontFamily: '"Inter", "Roboto", sans-serif',
          },
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          marginTop: '0.5rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: processed ? 'space-between' : 'flex-end',
            alignItems: 'center',
            mb: 0.5,
          }}
        >
          {!!processed && (
            <Typography variant="caption">
              <Box
                component="span"
                sx={{
                  fontSize: 12,
                  color: '#00875A',
                  display: 'inline',
                }}
              >
                {processed}{' '}
              </Box>
              / {total}
            </Typography>
          )}

          {!!failed && (
            <Typography variant="caption">
              <Box
                component="span"
                sx={{
                  fontSize: 12,
                  color: '#EF4444',
                  display: 'inline',
                }}
              >
                {failed}{' '}
              </Box>
              / {total}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            width: '100%',
            height: 4,
            maxHeight: 4,
            display: 'flex',
            overflow: 'hidden',
            borderRadius: 2,
            backgroundColor: '#E5E7EB',
          }}
        >
          <Box
            sx={{
              width: `${processedPercentage}%`,
              backgroundColor: '#00875A',
              transition: 'width 0.3s ease',
            }}
          />

          <Box
            sx={{
              width: `${failedPercentage}%`,
              backgroundColor: '#EF4444',
              transition: 'width 0.3s ease',
            }}
          />
        </Box>
      </Box>
    </Tooltip>
  );
};

export default BulkUploadProcessedStatusBar;
